import React from 'react'
import { RiSendPlaneLine } from "react-icons/ri";
import styles from './HeroContainer.module.css' 

const ExploreButton = () => {
  return (
    <button type='submit' className={styles.exploreButton}>Explore</button>
  )
}

export default ExploreButton